import React from 'react';
import {
  RenderRichTextData,
  ContentfulRichTextGatsbyReference,
} from 'gatsby-source-contentful/rich-text';

import Paragraph from '@/components/Paragraph';
import { ImageType } from '@/components/Image';
import { PHONE_NUMBER } from '@/utils/constants';
import Richtext from '@/components/Richtext';
import GenericBlock from './GenericBlock';
import NewBadge from './NewBadge';
import {
  AdditionalTextWrapper,
  HorizontalSeparator,
  PhoneNumber,
  // AvailabilityText,
  // AvailabilityTitle,
  // AvailabilityWrapper,
} from './ContactBlock.styles';

type Props = {
  title: string;
  text: string;
  image: ImageType;
  phoneDisplayNewBadge: boolean;
  phoneAdditionalText: RenderRichTextData<ContentfulRichTextGatsbyReference>;
};

const PhoneBlock: React.FC<Props> = (props) => {
  // prettier-ignore
  const {
    title,
    text,
    image,
    phoneDisplayNewBadge,
    phoneAdditionalText
  } = props;

  return (
    <GenericBlock image={image} title={title}>
      {text && <Paragraph size='lg'>{text}</Paragraph>}
      <HorizontalSeparator />
      <PhoneNumber href={`tel:${PHONE_NUMBER}`}>{PHONE_NUMBER}</PhoneNumber>
      {phoneAdditionalText && (
        <AdditionalTextWrapper>
          <NewBadge isEnabled={phoneDisplayNewBadge} />
          <Richtext
            data={phoneAdditionalText}
            options={{
              textSize: 'sm',
              noCheckMarkListIcons: true,
            }}
          />
        </AdditionalTextWrapper>
      )}
      {/* <AvailabilityWrapper>
        <AvailabilityTitle>{t('availabilityTitle')}</AvailabilityTitle>
        <AvailabilityText>
          <BBCode>{t('availabilityText')}</BBCode>
        </AvailabilityText>
      </AvailabilityWrapper> */}
    </GenericBlock>
  );
};

export default PhoneBlock;
